export const FETCH_HEADER_CONTENT = "FETCH_HEADER";
export const FETCH_FOOTER_CONTENT = "FETCH_FOOTER";
export const FETCH_HOME_PAGE_DATA = "LOAD_HOME_JSON";
export const FETCH_BBU_JSON = "LOAD_BBU_JSON";
//export const HOME_PAGE_DATA_URL = "http://10.118.3.122:4503/content/verizon/support/res/dynamic-page.model.json?pagename=home";
export const HOME_PAGE_DATA_URL = window.content_addr + "content/verizon/support/res/dynamic-page.model.json?pagename=home";
export const HEADER_URL = "https://wwwawssit.ebiz.verizon.com/includes/commongh/?type=resresponsive&clientid=respressupport";
export const FOOTER_URL = "https://wwwawssit.ebiz.verizon.com/includes/commongf/?type=resresponsive&clientid=respressupport";
//export const CMS_LOCATION = "http://10.118.3.122/";
export const CMS_LOCATION = window.content_addr;
export const INITIAL_SUGGESTIONS_URL = "https://wwwawssit.ebiz.verizon.com/search/AutoSuggest/headersearch/?Ntt=&action=GET_QUICK_LINKS&segments=ResidentialSupport&ES=ResidentialSupport";
export const RTCI_TOUCH_POINT_URL = "https://wwwawssit.ebiz.verizon.com/vcm/constructedtouchpoint";
export const IPCID_URL = "https://wwwawssit.ebiz.verizon.com/vcm/callme/timeslots";
export const ECRM_URL = "https://wwwawssit.ebiz.verizon.com/vcm/user/contactinfo";
export const MAIN_SERVER = "https://www.verizon.com/";
export const SIT_SERVER = "https://wwwawssit.ebiz.verizon.com/";
export const VZTC_URL = (window.location.href.indexOf('www.verizon.com') > -1) ? "https://comm.verizon.com/comm/includes/scripts/vztc.js" : "https://commstg.verizon.com/comm/includes/scripts/vztc.js";
// export const MS_LOCATION = window.content_addr + "supportservices/consumer";
export const MS_LOCATION = window.content_addr + "/support/consumer";
export const HOME_PAGE_CATEGORY = "TV Phone Internet Billing and Account  Customer Service";
export const CONTACT_US_PAGE_CATEGORY = "Verizon Help Center and? Support";
export const CONTACT_US_PAGE_SUBCATEGORY = "Verizon Customer Service  Contact Us";
export const REPAIR_STATUS_URL ="https://www.verizon.com/ForYourHome/VzRepair/FlowEngine/UFDService.aspx?Keyword=Web_TroubleTicket"


// WEBPACK FOOTER //
// ./src/constants/constants.js